// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"44":"724180e2a1c3815c0378","925":"f0fb9351764ea958a027"}[chunkId] + ".bundle.js";
};